import { useField } from 'formik';
import { Flex, Icon, Switch } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { Stars03 } from '@kula-ai/icons/outline/Stars03';

const VIDEO_LOCATIONS = ['zoom', 'google_meet', 'teams'];

// Gradient switch styles
const gradientSwitchStyles = {
  '& .chakra-switch__track': {
    bg: 'gray.200',
  },
  '& .chakra-switch__track[data-checked]': {
    bg: 'linear-gradient(181.67deg, #A3A7FF -4.05%, #BA72DF 98.58%)',
  },
  '& .chakra-switch__thumb': {
    boxShadow: '0px 2px 4px rgba(65, 59, 116, 0.5)',
  },
};

const FillWithAiContent = ({ isChecked, onToggle }) => (
  <Flex
    bg="#F9F5FF"
    borderRadius="8px"
    p="12px"
    mt="12px"
    justifyContent="space-between"
    alignItems="center"
  >
    <Flex flexDir="column" gap="6px" flex="1">
      <Flex alignItems="center" gap="6px">
        <Icon as={Stars03} w="16px" h="16px" color="#605AFB" flexShrink={0} />
        <KText
          fontSize="14px"
          fontWeight="550"
          lineHeight="20px"
          sx={{
            background: 'linear-gradient(180deg, #8A90FF 0%, #B15FDA 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Allow interviewers to complete scorecards with AI?
        </KText>
      </Flex>
      <KText fontSize="14px" fontWeight="450" lineHeight="20px" color="#6D659D">
        Helps draft scorecards faster, improving completion rates and
        consistency
      </KText>
    </Flex>
    <Switch
      size="md"
      sx={gradientSwitchStyles}
      cursor="pointer"
      isChecked={isChecked}
      onChange={onToggle}
      ml="12px"
      flexShrink={0}
    />
  </Flex>
);

const RefBasedFillWithAi = ({
  currentTab,
  showFillWithAi,
  location,
  fill_with_ai_enabled,
  note_taker_enabled,
  onFillWithAiChange,
}) => {
  if (
    currentTab !== 'scorecard' ||
    !showFillWithAi ||
    !note_taker_enabled ||
    !location ||
    !VIDEO_LOCATIONS.includes(location)
  ) {
    return null;
  }

  const onToggle = (event) => {
    const { checked } = event.target;
    onFillWithAiChange(checked);
  };

  return (
    <FillWithAiContent isChecked={fill_with_ai_enabled} onToggle={onToggle} />
  );
};

const FormikFillWithAi = () => {
  const [field, , helpers] = useField('fill_with_ai_enabled');
  const { setValue } = helpers;
  const { value } = field;
  const isFillWithAiEnabled = value ?? false;

  const onToggle = (event) => {
    const { checked } = event.target;
    setValue(checked);
  };

  return (
    <FillWithAiContent isChecked={isFillWithAiEnabled} onToggle={onToggle} />
  );
};

export const ScoreCardFillWithAi = ({
  currentTab = '',
  showFillWithAi = false,
  location = null,
  fill_with_ai_enabled = false,
  note_taker_enabled = false,
  onFillWithAiChange = null,
}) => {
  if (onFillWithAiChange) {
    return (
      <RefBasedFillWithAi
        key={currentTab}
        currentTab={currentTab}
        showFillWithAi={showFillWithAi}
        location={location}
        fill_with_ai_enabled={fill_with_ai_enabled}
        note_taker_enabled={note_taker_enabled}
        onFillWithAiChange={onFillWithAiChange}
      />
    );
  }
  return <FormikFillWithAi />;
};

export default ScoreCardFillWithAi;
